import { join } from 'path';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { FreteService } from 'src/app/services/frete.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TransportadoraService } from 'src/app/services/transportadora.service';
import { ModalidadeService } from 'src/app/services/modalidade.service';
import { Modalidade } from 'src/app/models/modalidade';
import { Transportadora } from 'src/app/models/transportadora';

@Component({
  selector: 'app-exportar-fretes-multi-cds-modal',
  templateUrl: './exportar-fretes-multi-cds-modal.component.html',
  styleUrls: ['./exportar-fretes-multi-cds-modal.component.scss']
})
export class ExportarFretesMultiCDsModalComponent implements OnInit {
  cds = [];
  cdsSelecionados = [];
  situacaoSelecionada = 'A';
  usarCentroDeDistribuicao = false;

  fornecedores = [];
  modalidades: Modalidade[] = [];
  modalidadeSelecionada;
  tipoOperacao: number = 0;
  transportadoras: Transportadora[] = [];
  transportadoraSelecionada = undefined;

  exibirModalidade: boolean = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<ExportarFretesMultiCDsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private freteService: FreteService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private fornecedorService: FornecedorService,
    private utilitarioService: UtilitarioService,
    private premissasService: PremissasService,
    private transportadoraService: TransportadoraService,
    private modalidadeService: ModalidadeService
  ) {
    this.tipoOperacao = this.data.tipoOperacao;
    this.modalidadeSelecionada = this.data.idMod;
    this.transportadoraSelecionada = this.data.idTransp;
    this.exibirModalidade = this.data.exibirModalidade;
  }

  ngOnInit() {
    this.buscarCDs();
    this.buscarPremissaCentroDeDistribuicao();
    this.buscarTransportadoras();
    this.buscarFornecedores();

    if (this.exibirModalidade) {
      this.buscarModalidadesExistentes();
    }

    if (this.data.cdSelecionado !== undefined && this.data.cdSelecionado !== null)
      this.cdsSelecionados.push(this.data.cdSelecionado);
  }

  buscarModalidadesExistentes() {
    if (!this.exibirModalidade) {
      return;
    }

    const idTransp = this.transportadoraSelecionada !== null && this.transportadoraSelecionada !== undefined && this.transportadoraSelecionada !== "-1" ? this.transportadoraSelecionada : null;

    this.carregandoService.mostra('buscarModalidades');

    this.modalidadeService.listarModalidadesExistentes(idTransp).subscribe(data => {
      this.modalidades = data;

      // const mod = new Modalidade();
      // mod.id = -1;
      // mod.descricao = 'SEM MODALIDADE';

      // if (!this.modalidades.some(m => m.id === mod.id)) {
      //   this.modalidades.unshift(mod);
      // }

      // if (!this.modalidadeSelecionada || !this.modalidades.some(m => m.id === this.modalidadeSelecionada)) {
      //   this.modalidadeSelecionada = mod.id;
      // }

      this.carregandoService.esconde('buscarModalidades');
    }, (erro) => {
      this.carregandoService.esconde('buscarModalidades');
      this.notificacaoService.erro('Não foi possível buscar as modalidades!');
    });
  }

  buscarTransportadoras() {
    this.carregandoService.mostra('buscarTransportadoras');

    this.transportadoraService.consultarTransportadoras().subscribe(dados => {
      this.transportadoras = dados;

      const novaTransp = new Transportadora();
      novaTransp.id = "-1";
      novaTransp.nome = 'SEM TRANSPORTADORA';

      if (!this.transportadoras.some(transp => transp.id === novaTransp.id)) {
        this.transportadoras.unshift(novaTransp);
      }

      if (!this.transportadoraSelecionada) {
        this.transportadoraSelecionada = novaTransp.id;
      }

      this.carregandoService.esconde('buscarTransportadoras');
    }, (erro) => {
      this.carregandoService.esconde('buscarTransportadoras');
    });
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');
    this.fornecedorService.consultarFornecedores().subscribe(
      forn => {
        this.carregandoService.esconde('buscarFornecedores');
        this.fornecedores = forn;
      },
      err => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      centro => {
        this.usarCentroDeDistribuicao = centro.valor;

        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      },
      err => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarCDs() {
    this.carregandoService.mostra('buscarCDs');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.cds = forn;

        this.carregandoService.esconde('buscarCDs');
      },
      (err) => {
        this.carregandoService.esconde('buscarCDs');
        this.notificacaoService.erro(err);
      }
    );
  }

  exportar() {
    this.carregandoService.mostra('baixarArquivo');

    const modalidade = this.modalidadeSelecionada !== null && this.modalidadeSelecionada !== undefined
      ? this.modalidadeSelecionada
      : null;
    const transportadora = this.transportadoraSelecionada !== null && this.transportadoraSelecionada !== undefined
      ? this.transportadoraSelecionada
      : null;

    this.freteService.exportarFretes(this.cdsSelecionados, true, modalidade, transportadora).subscribe(
      (arq) => {
        let nomeCD;

        if (this.usarCentroDeDistribuicao && this.cdsSelecionados) {
          if (this.cdsSelecionados.length == 1)
            nomeCD = this.fornecedores.find(p => p.id === this.cdsSelecionados[0]).descricao;
          else if (this.cdsSelecionados.length > 1)
            nomeCD = "Múltiplos CD's";
          else
            nomeCD = null;
        }

        const nomeMod = modalidade
          ? this.modalidades.find(m => m.id === modalidade).descricao
          : null;

        const nomeTransp = transportadora
          ? this.transportadoras.find(t => t.id === transportadora).nome
          : null;

        let nomeArquivo = 'PercentuaisDeFrete';

        if (nomeCD && nomeTransp && nomeMod) {
          nomeArquivo += `_${nomeCD}_${nomeTransp}_${nomeMod}.xlsx`;
        } else if (nomeCD && nomeTransp) {
          nomeArquivo += `_${nomeCD}_${nomeTransp}.xlsx`;
        } else if (nomeCD && nomeMod) {
          nomeArquivo += `_${nomeCD}_${nomeMod}.xlsx`;
        } else if (nomeMod && nomeTransp) {
          nomeArquivo += `_${nomeMod}_${nomeTransp}.xlsx`;
        } else if (nomeCD) {
          nomeArquivo += `_${nomeCD}.xlsx`;
        } else if (nomeMod) {
          nomeArquivo += `_${nomeMod}.xlsx`;
        } else if (nomeTransp) {
          nomeArquivo += `_${nomeTransp}.xlsx`;
        } else {
          nomeArquivo += '.xlsx';
        }

        this.utilitarioService.saveBlob(arq, nomeArquivo);
        this.carregandoService.esconde('baixarArquivo');
      },
      (erro) => {
        this.carregandoService.esconde('baixarArquivo');
        this.notificacaoService.erro('Para baixar os percentuais é necessário que existam fretes cadastrados!');
        console.error(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close({ cd: this.cdsSelecionados, idTransp: this.transportadoraSelecionada, idMod: this.modalidadeSelecionada });
  }
}
